import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChange,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { fromEvent } from "rxjs";
import { map, filter, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { FormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-navsearch",
  templateUrl: "./navsearch.component.html",
  styleUrls: ["./navsearch.component.scss"],
  imports: [FormsModule, TranslatePipe],
})
export class NavsearchComponent implements OnInit, OnChanges {
  @ViewChild("search", { static: true }) searchInput: ElementRef;
  @Input() visible: boolean;
  @Output() onclose = new EventEmitter<boolean>();
  term: string;

  constructor(public elem: ElementRef) {}

  ngOnInit() {
    document.addEventListener("keyup", (event) => {
      if (event.keyCode === 27) {
        // ESC
        this.closeNavSearch();
      }
    });
    document.addEventListener("click", (event) => {
      const contains =
        this.elem.nativeElement !== event.target &&
        this.elem.nativeElement.contains(event.target);
      if (!contains) {
        this.closeNavSearch();
      }
    });

    fromEvent(this.searchInput.nativeElement, "keyup")
      .pipe(
        map((event: any) => {
          return event.target.value;
        }),
        filter((res) => res.length > 2),
        debounceTime(1000),
        distinctUntilChanged(),
      )
      .subscribe((text: string) => {});
  }

  closeNavSearch() {
    this.visible = false;
    this.onclose.emit();
  }

  ngOnChanges(changes: Record<string, SimpleChange>) {
    //
    if (changes.visible.currentValue === true) {
      this.elem.nativeElement.querySelector("input").focus();
    }
  }

  handleForm() {}
}
